// constants
import { commonImage } from 'constants/images';

// libraries
import Box from '@mui/material/Box';
import styled from 'styled-components';

interface IStyledBasicModalV2 {
  width?: string | number;
  height?: string | number;
  isScroll?: boolean;
}

export const StyledBasicModalV2 = styled(Box)<IStyledBasicModalV2>`
  padding: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${(props) => (props.width ? props.width : null)};
  background-color: #fff;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  overflow: hidden;

  #modal-modal-title {
    padding: 28px 18px;
    border-bottom: 1px solid #e6e6e6;
    background: #fff;
  }

  #modal-modal-description {
    padding: 29px 35px;
  }

  .modalHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 66px;
    padding: 0 20px 0 28px;
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid #e6e6e6;
    box-sizing: border-box;

    .modalCloseButton {
      width: 24px;
      height: 24px;
      background-image: url(${commonImage.modalClose});
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }

  .modalBody {
    padding: 25px 28px 60px 25px;
    height: ${(props) => (props.height ? props.height : null)};
    overflow-y: ${(props) => (props.isScroll ? 'scroll' : 'hidden')};
    text-align: center;
    /* overflow-y: scroll; */

    > p {
      padding: 15px 0;
    }
  }

  .modalButtons {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;

    button {
      margin-left: 12px;
      & + button {
        margin-left: 12px;
      }
    }
  }
`;
